import { Navigate, useLocation } from "react-router-dom";

export default function LandingPage() {
  const location = useLocation();

  const redirectLink = `/sign-up${location.search}`;

  return <Navigate to={redirectLink} />;
}
